/*
Update swiper elements on resize
 */
function updateSwiperElements() {
    jQuery(swiperElements).each(function(index, swiperEl) {
        swiperEl.update();
    });
}

jQuery(window).on('resize',updateSwiperElements);
